import { updateAddress } from '@/api'
import { useMutation, UseMutationOptions } from 'react-query'
import { getGeocode } from 'use-places-autocomplete'

type AddressInput = {
  street: string
  streetNr: string
  postalCode: string
  city: string
  country: string
}

export const useUpdateAddress = (id: number) =>
  useMutation(({ street, streetNr, postalCode, city, country }: AddressInput) =>
    updateAddress({
      id,
      street,
      streetNr,
      postalCode,
      city,
      country,
    }),
  )

export const useAddress = (
  options?: UseMutationOptions<google.maps.GeocoderResult[], unknown, string>,
) =>
  useMutation<google.maps.GeocoderResult[], unknown, string>(
    async (placeId: string) => getGeocode({ placeId }),
    options,
  )
